import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from '@xyflow/react';
import { useSegmentationCanvasStore } from '../model/segmentation-canvas-store';
import type { ConnectorEdge } from '../model/segmentation-mapper';

/** Aresta da cadeia entre grupos — o rótulo E/Ou é o controle do conector
 * entre grupos (distinto do E/Ou interno de cada card, que combina condições
 * dentro do mesmo grupo). */
export function SegmentationConnectorEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: EdgeProps<ConnectorEdge>) {
  const setChainConnector = useSegmentationCanvasStore((s) => s.setChainConnector);
  const connector = data?.connector ?? 'AND';
  const chainIndex = data?.chainIndex ?? 0;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        <button
          type="button"
          className="nodrag nopan absolute rounded-md border border-border/80 bg-card px-2 py-0.5 text-xs font-semibold shadow-sm hover:border-primary hover:text-primary"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: 'all',
          }}
          aria-label={connector === 'AND' ? 'Conector E — clicar para Ou' : 'Conector Ou — clicar para E'}
          onClick={() => setChainConnector(chainIndex, connector === 'AND' ? 'OR' : 'AND')}
        >
          {connector === 'AND' ? 'E' : 'Ou'}
        </button>
      </EdgeLabelRenderer>
    </>
  );
}
